export default "<router-outlet></router-outlet>\n<loader></loader>\n"